import { render, staticRenderFns } from "./internshipreportview.vue?vue&type=template&id=19e1cbc0&scoped=true&"
import script from "./internshipreportview.vue?vue&type=script&lang=js&"
export * from "./internshipreportview.vue?vue&type=script&lang=js&"
import style0 from "./internshipreportview.vue?vue&type=style&index=0&id=19e1cbc0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e1cbc0",
  null
  
)

export default component.exports